import React from 'react';
import { Laptop, Database, ShieldAlert, Gamepad2, FileText, CheckCircle, Apple, MapPin, Phone } from 'lucide-react';
import { Service, Testimonial, BlogPost, LocationInfo } from './types.ts';

export const BUSINESS_PHONE = "0468 991 300";
export const BUSINESS_NAME = "Brisbane Computer Fix";
export const BUSINESS_EMAIL = "ike@brisbanecomputerfix.com";
export const BUSINESS_ABN = "98 288 669 674";
export const GOOGLE_REVIEWS_URL = "https://g.page/computer-geek";
export const INSTAGRAM_URL = "https://www.instagram.com/brisbanecomputerfix/";
export const LINKEDIN_URL = "https://au.linkedin.com/company/brisbane-computer-fix";
export const FACEBOOK_URL = "https://www.facebook.com/brisbanecomputerfix/";

export const COVERED_POSTCODES = [
  '4066', '4068', '4067', '4069', '4032', '4101', '4006', '4064', '4065', '4075', '4000', 
  '4169', '4104'
];

export const SERVICES: Service[] = [
  {
    id: 'macbook',
    title: 'MacBook Excellence',
    description: 'Screen replacements, liquid damage, and battery swaps for Air & Pro models. Specialist expertise for hardware that others often refuse to touch.',
    icon: <Apple className="w-8 h-8" />
  },
  {
    id: 'data-recovery',
    title: 'Data Recovery Specialist',
    description: 'Recovering family photos and business files from failed hard drives or corrupted USBs in Brisbane.',
    icon: <Database className="w-8 h-8" />
  },
  {
    id: 'senior-health',
    title: 'Senior Digital Health Check',
    description: 'Removal of hidden scams, securing online banking, and speed optimization for ease of use.',
    icon: <ShieldAlert className="w-8 h-8" />
  },
  {
    id: 'gaming',
    title: 'Gaming & Custom Builds',
    description: 'Performance PC builds with cable management, stress-testing, and liquid cooling setups.',
    icon: <Gamepad2 className="w-8 h-8" />
  },
  {
    id: 'insurance',
    title: 'Insurance Reports',
    description: 'Official damage assessments and repair quotes for Suncorp, RACQ, and Allianz claims.',
    icon: <FileText className="w-8 h-8" />
  },
  {
    id: 'repair',
    title: 'General Repairs',
    description: 'Slow laptops, Windows crashes, and component upgrades to make your old PC feel brand new.',
    icon: <Laptop className="w-8 h-8" />
  }
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: '1',
    text: "Ike replaced my Mac hard drive in record time. He is a master technician and brilliant with his work. Recommended to all my friends!",
    author: "Georg B.",
    role: "Doctor",
    location: "Auchenflower"
  },
  {
    id: '2',
    text: "Honest and transparent. The fixed price $170 quote was exactly what I paid. No hidden fees or travel costs. My laptop is fast again!",
    author: "Margaret S.",
    location: "Indooroopilly"
  },
  {
    id: '3',
    text: "He explained everything in plain English without the technical jargon. As a senior, I really appreciated the respect and patience Ike showed.",
    author: "Robert H.",
    location: "Kenmore"
  }
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 'b1',
    title: '"Stop the Scammers:" A 2025 checklist for Brisbane seniors.',
    excerpt: "Learn how to spot fraudulent phone calls and emails targeting our local community.",
    date: "March 12, 2024"
  },
  {
    id: 'b2',
    title: "Don't Buy New Yet!",
    excerpt: "How a $90 SSD upgrade makes your 5-year-old laptop feel brand new again.",
    date: "Feb 28, 2024"
  },
  {
    id: 'b3',
    title: "MacBook Water Damage?",
    excerpt: "The 3 things you must do in the first 10 minutes to save your data.",
    date: "Jan 15, 2024"
  }
];

export const LOCATIONS: LocationInfo[] = [
  {
    name: "Indooroopilly Lab (HQ)",
    address: "5 Grosvenor Rd, Indooroopilly QLD 4068",
    hours: "Mon–Sun: 8:00 AM – 9:00 PM"
  },
  {
    name: "East Brisbane Hub",
    address: "Stanley St, East Brisbane QLD 4169",
    hours: "Appt Only: 8:00 AM – 6:00 PM"
  },
  {
    name: "Teneriffe Studio",
    address: "Commercial Rd, Teneriffe QLD 4005",
    hours: "Appt Only: 9:00 AM – 5:00 PM"
  }
];

export const PILLARS = [
  {
    title: "Master Hardware Specialist",
    desc: "Elite repair expertise for all major brands, providing solutions where others give up.",
    icon: <CheckCircle className="text-green-600" />
  },
  {
    title: "$170 Fixed Price Quotes",
    desc: "No hourly rates. No 'bill shock'. No travel fees.",
    icon: <CheckCircle className="text-green-600" />
  },
  {
    title: "No Fix, No Fee Guarantee",
    desc: "Pay $0 if we can't fix it or recover files. (Excludes liquid damage repairs).",
    icon: <CheckCircle className="text-green-600" />
  },
  {
    title: "Plain English Only",
    desc: "We explain the problem without the tech-jargon.",
    icon: <CheckCircle className="text-green-600" />
  }
];